// responsive menu behavior

import $ from 'jquery';

Drupal.behaviors.troaxResponsiveMenu = {
  attach() {
    $('.resp-trigger').once('troaxResponsiveMenu').each((index, element) => this.responsiveMenuBehavior(element));
  },
  responsiveMenuBehavior(element) {
    $(element).click((e) => {
      e.preventDefault();
      e.stopPropagation();
      const selected = $(element);

      // Toggle icon
      selected.find('.resp-icon').find('.fa-chevron-down').toggleClass('chevron-toggle');

      // // Collapse other open submenues --- FIX THIS --- Om man klickar på sin egen
      $('.resp-submenu').not(selected).addClass('resp-is-hidden');

      // Bring icon back to normal state on other open submenues
      $('.resp-trigger').not(selected).find('.fa-chevron-down').removeClass('chevron-toggle');

      // Toggle sub-menu
      selected.siblings('.resp-submenu').toggleClass('resp-is-hidden');

      // Close submenu if parent is clicked
      selected.siblings('.resp-submenu').toggleClass('is-open');

      if (selected.siblings('.resp-submenu').hasClass('is-open')) {
        selected.siblings('.resp-submenu').removeClass('resp-is-hidden');
        $('.resp-trigger').not(selected).find('.fa-chevron-down').removeClass('chevron-toggle');
      } else {
        selected.siblings('.resp-submenu').addClass('resp-is-hidden');
        $('.resp-trigger').find('.fa-chevron-down').removeClass('chevron-toggle');
      }
    });
  },
};
